import { CORAL_COLORS, type CoralForm, type ReefState } from "./coral-chorus-core";

export const CORAL_FORM_NAMES: Record<CoralForm, string> = {
  antlers: "Branching antlers", tendrils: "Curling tendrils", fan: "Broad fans",
  plates: "Stacked plates", cluster: "Rounded clusters", tubes: "Tubes",
};
const escape = (text: string) => text.replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

// Read the shared scene directly so room updates, undo, reset and resume stay in sync.
export function coralPlacementLogHtml(state: ReefState): string {
  if (!state.pieces.length) return '<p class="cc-log-empty">Your first little addition will appear here.</p>';
  return `<ol class="cc-log-list">${state.pieces.map((piece, i) => {
    const name = state.players[piece.player] ?? `Player ${piece.player + 1}`;
    const color = CORAL_COLORS.find(c => c.hex === piece.color)!;
    return `<li><span class="cc-log-number" aria-label="Placement ${i + 1}">${i + 1}</span><i class="cc-log-swatch" style="background:${color.hex}" aria-hidden="true"></i><div><p><strong>${escape(name)}</strong> placed <span>${CORAL_FORM_NAMES[piece.form].toLowerCase()}</span></p><small>${color.name} · Size ${piece.size} · Rotation ${piece.rotation}°</small></div><button class="cc-admire cc-log-step" type="button" data-cc-step="${i + 1}" aria-label="View step ${i + 1}" aria-pressed="false">View step <span aria-hidden="true">↗</span></button></li>`;
  }).join("")}</ol>`;
}
